module.exports = __webpack_public_path__ + "static/media/education.1214df96.png";